import { render, staticRenderFns } from "./modifica.vue?vue&type=template&id=094e7302&scoped=true&"
import script from "./modifica.vue?vue&type=script&lang=js&"
export * from "./modifica.vue?vue&type=script&lang=js&"
import style0 from "./modifica.vue?vue&type=style&index=0&id=094e7302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094e7302",
  null
  
)

export default component.exports